// extracted by mini-css-extract-plugin
export default {"pageContainer":"IsaacPdfViewer_pageContainer__FfIfR"};